"use client";

import { c as _c } from "react/compiler-runtime";
import { SocialShareButtons } from "@/components/Social/SocialShare";
import { baseUrl } from "@/constants/project-specific";
import { Post } from "@/lib/directus/posts";
import { getDirectusMedia } from "@/lib/directus/utils";
import { timeFromNow } from "@/util/dateUtils";
import { Card, CardHeader, Avatar, CardBody } from "@heroui/react";
import { Link } from "lucide-react";
function ArticleDisplay(t0) {
  const $ = _c(44);
  const {
    post,
    slug
  } = t0;
  let t1;
  if ($[0] !== post.title) {
    t1 = <h1 className="fluid-lg self-center text-center w-full">{post.title}</h1>;
    $[0] = post.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link href="../news" className="text-white">News</Link>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = post.categories?.[0]?.chewy_categories_slug?.title ?? "Article";
  let t4;
  if ($[3] !== t3) {
    t4 = <div className="md:mx-6 self-center">{t2} {">"}{" "}{t3}</div>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== post.date_created) {
    t5 = (post.date_created ? new Date(post.date_created) : new Date()).toISOString();
    $[5] = post.date_created;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== post.date_created) {
    t6 = post.date_created ?? new Date();
    $[7] = post.date_created;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = timeFromNow(t6);
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t7) {
    t8 = <span className="text-left fluid-md pl-2 text-gray-400 self-center"><time dateTime={t5}>{t7}</time></span>;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = typeof post.article_author?.avatar === "object" ? post.article_author?.avatar.filename_disk : undefined;
  let t10;
  if ($[14] !== t9) {
    t10 = getDirectusMedia(t9);
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10) {
    t11 = <Avatar src={t10} size="sm" className="inline-block align-middle ml-3 mr-2 w-6 h-6" />;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== post.article_author?.name) {
    t12 = post.article_author?.name.toLowerCase() ?? "contact";
    $[18] = post.article_author?.name;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const t13 = `mailto:${t12}@chewyswap.dog`;
  const t14 = post.article_author?.name ?? "ChewySwap";
  let t15;
  if ($[20] !== t13 || $[21] !== t14) {
    t15 = <span className="w-full text-left fluid-md text-gray-400">By{" "}<a href={t13} color="secondary">{t14}</a></span>;
    $[20] = t13;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t11 || $[24] !== t15 || $[25] !== t8) {
    t16 = <div className="inline-block pt-2 md:pt-0 self-end">{t8}{t11}{" "}{t15}</div>;
    $[23] = t11;
    $[24] = t15;
    $[25] = t8;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t16 || $[28] !== t4) {
    t17 = <div className="flex flex-row justify-between w-full pt-2">{t4}{t16}</div>;
    $[27] = t16;
    $[28] = t4;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t1 || $[31] !== t17) {
    t18 = <CardHeader className="bg-white/5"><div className="flex flex-col w-full py-1">{t1}{t17}</div></CardHeader>;
    $[30] = t1;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  const t19 = post.content as unknown as TrustedHTML;
  let t20;
  if ($[33] !== t19) {
    t20 = <article><div className="flex flex-col p-1 w-full"><div className="prose dark:prose-invert prose-orange content-center self-center pb-6" dangerouslySetInnerHTML={{
          __html: t19
        }} /></div></article>;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  const t21 = `${baseUrl}/news/${slug}`;
  let t22;
  if ($[35] !== post.title || $[36] !== t21) {
    t22 = <div className="pt-6 pb-8 mb-4 self-center w-full bg-gradient-to-r from-slate-800/25 via-slate-700/25 to-slate-800/25 rounded-lg"><SocialShareButtons url={t21} message={post.title} shareMessage="Spread the word, Tap to Share!" /></div>;
    $[35] = post.title;
    $[36] = t21;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== t20 || $[39] !== t22) {
    t23 = <CardBody className="w-full px-2 md:px-10">{t20}{t22}</CardBody>;
    $[38] = t20;
    $[39] = t22;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== t18 || $[42] !== t23) {
    t24 = <Card className="cards-blog max-w-4xl w-full mb-10">{t18}{t23}</Card>;
    $[41] = t18;
    $[42] = t23;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  return t24;
}
export default ArticleDisplay;